import React from 'react';
import './fullscreenLoader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'; 

const FullscreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      <img 
        src="/static/media/nus-logo.b803bec4922af8016b89.png" 
        alt="NUS Logo" 
        className="logo"
      />
      <div className="loader">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
    </div>
  );
};

export default FullscreenLoader;
